import { useState } from "react";

export function useSettingsModals() {
  const [isInviteModalOpen, setIsInviteModalOpen] = useState(false);
  const [isEditModalOpen, setIsEditModalOpen] = useState(false);
  const [selectedUserForEdit, setSelectedUserForEdit] = useState<any>(null);

  // Función para abrir el modal de edición
  const handleEditUser = (user: any) => {
    setSelectedUserForEdit(user);
    setIsEditModalOpen(true);
  };

  // Función para cerrar el modal de edición
  const handleCloseEditModal = () => {
    setIsEditModalOpen(false);
    setSelectedUserForEdit(null);
  };

  return {
    // States
    isInviteModalOpen,
    isEditModalOpen,
    selectedUserForEdit,

    // Setters
    setIsInviteModalOpen,
    setIsEditModalOpen,
    setSelectedUserForEdit,

    // Handlers
    handleEditUser,
    handleCloseEditModal,
  };
}
